export default "__VITE_ASSET__BTcfqyLp__"